export const ASSERT_URL_QUERY_KEY_BASE = ["asset-url"];

export const getAssetUrlQueryKey = (assetId: string | null | undefined) => [...ASSERT_URL_QUERY_KEY_BASE, assetId];
